define('models/customer_note',['require','backbone'],function(require){

    var Backbone = require('backbone');

    return Backbone.Model.extend({
        url : function() {
            // set the endpoint for restful api for articles
            return this.id ? ( App.Config.apiBase + 'customer-notes/' + this.id + '/' ) :
                ( App.Config.apiBase + 'customer-notes/' );
        },

        defaults: function () {
            return {
                id: null,
                customer: null,
                note: '',
                created: ''
            };
        }
    });
});
